import { en } from './en';
import { mr } from './mr';
import { kn } from './kn';

export const translations = {
  en,
  mr,
  kn
};

export const availableLanguages = [
  { code: 'en', label: 'English', short: 'EN', native: 'English' },
  { code: 'mr', label: 'मराठी', short: 'मराठी', native: 'मराठी' },
  { code: 'kn', label: 'ಕನ್ನಡ', short: 'ಕನ್ನಡ', native: 'ಕನ್ನಡ' }
];
